import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgXlm = function SvgXlm(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#000"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m90.61 33.36-10.18 5.187-49.156 25.038a29.5 29.5 0 0 1-.25-3.824 29.284 29.284 0 0 1 43.562-25.527l5.826-2.97.87-.443a35.768 35.768 0 0 0-56.676 31.673 6.51 6.51 0 0 1-3.533 6.288L18 70.35v7.307l9.046-4.61 2.93-1.495 2.886-1.47 51.821-26.405 5.823-2.965 12.036-6.134v-7.304zM102.542 41.888l-66.736 33.98-5.824 2.972L18 84.946v7.3l11.9-6.062 10.18-5.187 49.207-25.074q.25 1.917.25 3.85a29.284 29.284 0 0 1-43.605 25.523l-.358.19-6.317 3.22a35.768 35.768 0 0 0 56.679-31.68 6.51 6.51 0 0 1 3.53-6.289l3.076-1.567z"
    })));
};

export { SvgXlm as ReactComponent };
//# sourceMappingURL=XLM.svg.es.js.map
